class FilterStatics {
    static  specifc1 = 'type';
    static  specifc2 = 'model';
    static  specifc3 = 'group';
    static  specifc4 = 'kind';
}

export default FilterStatics;